import React from 'react';
import './App.css';
import ImageWithFallback from "./ImageWithFallback";

const CarGame = () => {
  return (
    <div className="page-container">
      <div className="hero-section">
        <h1>Car Game</h1>
        <p>Enjoy this fun car racing game coded in Python.</p>
        <ImageWithFallback src="/car_game.png" alt="Car Game" className="hero-image" />
      </div>
      <div className="content-section">
        <h2>Project Description</h2>
        <p>This project is a simple car racing game built using Python's Pygame library.</p>
        <h2>Download</h2>
        <a href="/Car game.py" download>Download Car game.py</a>
        <h2>How to Play</h2>
        <p>Run the Python file and use arrow keys to control the car and avoid obstacles.</p>
      </div>
    </div>
  );
};

export default CarGame;
